import styled from 'styled-components'

import { Carat } from '@syconium/little-miss-figgy/dist/components/Icons/Icon/Carat'
import { focusOutlineInset } from '@syconium/little-miss-figgy/dist/utility-classes'

import { NavSubMenuDialog } from '../NavSubMenuDialog'

// Separate styles are needed to compensate for pages router differences
export const TriggerRow = styled.button<{ $hasPadding?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${o => (o.$hasPadding ? o.theme.spacing(4) : '0px')};
  color: inherit;
  text-align: start;
  ${focusOutlineInset};
`

export const TriggerCaret = styled(Carat).attrs({ strokeWidth: 1 })`
  height: 15px;
  width: 15px;
  margin-inline-end: ${o => o.theme.dimensions.layout.sidePadding.md}px;
  flex-shrink: 0;
`

export const StyledNavSubMenuDialog = styled(NavSubMenuDialog)``
